/**
 * Dropdown de tri de la barre collection / recherche.
 *
 * Le composant ne construit aucune URL : il pousse la valeur choisie dans le
 * <select is="facet-short"> du thème, qui gère seul le re-rendu AJAX et la
 * préservation des filtres actifs.
 */
class SortDropdown extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.collection-sort__toggle');
    this.list = this.querySelector('.collection-sort__list');
    this.select = this.querySelector('select');

    if (!this.toggle || !this.list || !this.select) return;

    this.onToggleClick = this.onToggleClick.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.toggle.addEventListener('click', this.onToggleClick);
    this.list.addEventListener('click', this.onOptionClick);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  get isOpen() {
    return this.toggle.getAttribute('aria-expanded') === 'true';
  }

  setOpen(open) {
    this.toggle.setAttribute('aria-expanded', String(open));
    this.list.hidden = !open;
  }

  onToggleClick() {
    this.setOpen(!this.isOpen);
  }

  onOptionClick(event) {
    const option = event.target.closest('.collection-sort__option');
    if (!option) return;

    this.setOpen(false);
    if (option.value === this.select.value) return;

    this.select.value = option.value;
    this.select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onDocumentClick(event) {
    if (this.isOpen && !this.contains(event.target)) this.setOpen(false);
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.setOpen(false);
      this.toggle.focus();
    }
  }
}

if (!customElements.get('sort-dropdown')) {
  customElements.define('sort-dropdown', SortDropdown);
}
